import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "timezoneOffset",
    standalone: true,
})
export class TimezoneOffsetPipe implements PipeTransform {
    transform(offsetHours: number): string {
        if (offsetHours === null || offsetHours === undefined) {
            return "Unknown";
        }

        // Mapping of UTC offsets to timezone abbreviations
        // Note: This doesn't account for DST - shows both possibilities
        const offsetMap: { [key: string]: string } = {
            "-10": "HST",
            "-9": "AKST", // Alaska
            "-8": "PST", // Pacific
            "-7": "MST/PDT", // Mountain/Pacific DST
            "-6": "CST/MDT", // Central/Mountain DST
            "-5": "EST/CDT", // Eastern/Central DST
            "-4": "AST/EDT", // Atlantic/Eastern DST
            "-3.5": "NST", // Newfoundland
            "-3": "ART/BRT", // Argentina/Brazil
            "0": "UTC/GMT", // UTC/Greenwich
            "1": "CET", // Central European
            "2": "EET", // Eastern European
            "3": "MSK", // Moscow
            "4": "GST", // Gulf
            "5": "PKT", // Pakistan
            "5.5": "IST", // India
            "6": "BST", // Bangladesh
            "7": "ICT", // Indochina
            "8": "CST", // China/Singapore
            "9": "JST", // Japan
            "10": "AEST", // Australian Eastern
            "11": "AEDT", // Australian Eastern DST
            "12": "NZST", // New Zealand
        };

        // Return mapped timezone or fallback to UTC notation
        return offsetMap[offsetHours.toString()] || `UTC${offsetHours >= 0 ? "+" : ""}${offsetHours}`;
    }
}
